/* eslint-disable no-unused-vars */
import React, { FC } from 'react';
import {
  GetTransactionsViaTransactionNoResponse,
  LooseLeafBusinessInfo,
  TransactionPrintPageData
} from 'src/types';
import { Page as PDFPage, View, StyleSheet } from '@react-pdf/renderer';
import { RenderCustomerInfo } from './RenderCustomerInfo';
// import { RenderEmployeeInfo } from './RenderEmployeeInfo';
import { RenderItemsTable } from './RenderItems';
import { RenderPageNoAndTotal } from './RenderPageNoAndTotal';
import { RenderWarrantySlipTitle } from './RenderWarrantySlipTitle';
import { RenderFooter } from './RenderFooter';
import { RenderVatComputation } from './RenderVatComputation';

interface Props {
  pagesData?: TransactionPrintPageData[];
  transactionStateData?: GetTransactionsViaTransactionNoResponse | null;
  dateSold?: string;
  isSIPricing?: boolean;
  isTwoThreeOSeven?: boolean;
  isVATExempted?: boolean;
  totalAmount?: number;
  releasedBy?: string;
  storeBranch?: string;
  overrideOnURL?: string;
  looseLeafBusinessInfo?: LooseLeafBusinessInfo;
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: 'white'
  },
  container: {
    margin: 15,
    flex: 1,
    paddingHorizontal: 20
  }
});

export const RenderPages: FC<Props> = ({
  pagesData,
  transactionStateData,
  dateSold,
  isSIPricing,
  totalAmount,
  // releasedBy,
  storeBranch = '',
  overrideOnURL = '',
  isTwoThreeOSeven = false,
  isVATExempted = false,
  looseLeafBusinessInfo
}) => {
  return (
    <>
      {pagesData?.map((pageData, i) => (
        <PDFPage key={i} size={[612, 792]} style={styles.page}>
          <View style={styles.container}>
            <RenderCustomerInfo
              overrideOnURL={overrideOnURL}
              dateSold={dateSold}
              customerInfo={transactionStateData?.customer}
              looseLeafBusinessInfo={looseLeafBusinessInfo}
              paymentMode={transactionStateData?.payment_mode}
              transactionStateData={transactionStateData}
            />

            <RenderItemsTable
              items={pageData?.page?.items}
              kachiPoints={transactionStateData?.kachi_points}
              voucherDiscount={transactionStateData?.voucher_discount}
              voucher_code={transactionStateData?.voucher_code}
              isLastPage={i === pagesData.length - 1}
            />

            <RenderPageNoAndTotal
              pageNo={pageData?.pageNo}
              pageTotal={pagesData?.length}
              isSIPricing={isSIPricing}
              totalAmount={totalAmount}
              orderNo={transactionStateData?.order_no}
              transactionNo={transactionStateData?.transaction_no}
              storeBranch={storeBranch}
            />

            <RenderVatComputation
              isTwoThreeOSeven={isTwoThreeOSeven}
              isVATExempted={isVATExempted}
              totalTransactionAmount={totalAmount}
            />
          </View>
        </PDFPage>
      ))}
    </>
  );
};
